import { createFileRoute } from "@tanstack/react-router";

import { InterviewSummaryScreen } from "../features/interview/summary/InterviewSummaryScreen.tsx";

function SummaryRoute() {
  const { id } = Route.useParams();
  return <InterviewSummaryScreen meetingId={id} />;
}

export const Route = createFileRoute("/_app/interviews/$id/summary")({
  component: SummaryRoute,
});
